import React from 'react';
import { Pressable, Input } from 'native-base';
import { SpIcon } from '~/shared/Icon';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ProductListPageProps, useDutchieStore, useI18n } from '@springbig/shared';
import { useAppNavigate } from '~/pages';
import { useShopStyles } from '~/shared/styles';

export type SearchBarProps = {
  backgroundColor: string;
};

export const SearchBar = ({
    backgroundColor,
}: SearchBarProps) => {

    const { icon, sub_text } = useShopStyles();
    const {
        retailer,
        setProductListProps,
        isBusy,
    } = useDutchieStore();
    const { navigate, params } = useAppNavigate();
    const { t } = useI18n();

    const [searchValue, setSearchValue] = React.useState('');
    const handleChange = (text: string): void => setSearchValue(text);
    const onSubmitSearch = (): void => {

        const productListProps: ProductListPageProps = {
            title: searchValue,
            search: searchValue,
        };
        setSearchValue('');
        setProductListProps(productListProps);
        navigate(`w/${params.wallet_id}/shop/product_list`);
    };

    const onHandleKeyPress = (event): void => {

        if (event.nativeEvent.key === 'Enter') {

            onSubmitSearch();
        }
    };

    return (
        <Input
            bg={backgroundColor}
            placeholder={`${t('shop.search')} ${retailer?.name}`}
            borderWidth={0}
            h={10}
            w={'100%'}
            color={sub_text}
            value={searchValue}
            onChangeText={handleChange}
            onKeyPress={onHandleKeyPress}
            rightElement={
                <Pressable
                    px={2}
                    isDisabled={isBusy}
                    onPress={onSubmitSearch}
                >
                    <SpIcon
                        size={20}
                        color={icon}
                        icon={faSearch}
                        opacity={searchValue ? 1 : .5}
                    />
                </Pressable>
            }
        />
    );
};
